export const MODAL_TYPES = Object.freeze({
	None: 0,
	Edit: 1,
	DeleteFixIt: 2,
	Delete: 3,
});
